import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './index.css';
import React, { useEffect, useMemo, useContext, useRef, useState } from 'react';
import debounce from 'lodash/debounce';
/* import ScrollAnimation from 'react-animate-on-scroll'; */
import { Text } from "@sitecore-jss/sitecore-jss-react";
import { getColorByTheme, getDictionaryItem, getPageThemeColors, get, canUseDOM, hexToRgb } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { ReactComponent as IconChevronDown } from '../../resources/icons/chevron-down.svg';
import { ReactComponent as IconChevronAltDown } from '../../resources/icons/chevron-alt-down.svg';
import { ReactComponent as IconSwap } from '../../resources/icons/swap.svg';
import { ReactComponent as IconCalendar } from '../../resources/icons/calendar-fly-dubai.svg';
import CountersGroup from './components/CountersGroup';
import Datepicker from './components/DatePicker';
import LocationSelect from './components/LocationSelect';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
export var emptyDateShowObj = {
  day: '',
  dayNumber: '',
  month: '',
  monthNumber: '',
  year: ''
};
var emptyDestination = {
  value: '',
  label: ''
};
var getClassName = function getClassName(economy) {
  return economy ? 'Economy' : 'Business';
};
var FlyDubaiWidget = function FlyDubaiWidget(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    rendering = _ref.rendering;
  /* Context elements */
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl || false);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var lang = sitecoreContext && sitecoreContext.language || 'en';
  /* End context elements */

  /* Params elements */
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  /* End Params elements */

  /* Field props */
  var _fields$data = fields.data,
    dictionary = _fields$data.dictionary,
    contextItem = _fields$data.contextItem;
  var returnChangeAnalytics = get(fields, 'data.returnChangeAnalytics');
  var searchSubmitAnalytics = get(fields, 'data.searchSubmitAnalytics');
  /* End field props */

  /* Dictionary terms */
  var titleWidgetText = getDictionaryItem(dictionary, 'titleWidget') || '';
  var returnText = getDictionaryItem(dictionary, 'return') || '';
  var oneWayText = getDictionaryItem(dictionary, 'oneWay') || '';
  var fromText = getDictionaryItem(dictionary, 'from') || '';
  var toText = getDictionaryItem(dictionary, 'to') || '';
  var enterDepartureText = getDictionaryItem(dictionary, 'enterDeparture') || '';
  var pleaseEnterOrigin = getDictionaryItem(dictionary, 'pleaseEnterOrigin') || '';
  var enterDestinationText = getDictionaryItem(dictionary, 'enterDestination') || '';
  var pleaseEnterDestination = getDictionaryItem(dictionary, 'pleaseEnterDestination') || '';
  var useCurrentLocationText = getDictionaryItem(dictionary, 'useCurrentLocation') || '';
  var loadNMoreDestinationsText = getDictionaryItem(dictionary, 'loadNMoreDestinations') || '';
  var mostPopularText = getDictionaryItem(dictionary, 'mostPopular') || '';
  var enterValidDeparture = getDictionaryItem(dictionary, 'enterValidDeparture') || '';
  var enterValidDestination = getDictionaryItem(dictionary, 'enterValidDestination') || '';
  var searchHereText = getDictionaryItem(dictionary, 'searchHere') || '';
  var dateDeskPlaceholderDepartureText = getDictionaryItem(dictionary, 'dateDeskPlaceholderDeparture') || '';
  var dateDeskPlaceholderReturnText = getDictionaryItem(dictionary, 'dateDeskPlaceholderReturn') || '';
  var dateMobileStateSelectDepartureDateText = getDictionaryItem(dictionary, 'dateMobileStateSelectDepartureDate') || '';
  var dateMobileStateSelectReturnDateText = getDictionaryItem(dictionary, 'dateMobileStateSelectReturnDate') || '';
  var dateMobilePlaceholderDepartureDateText = getDictionaryItem(dictionary, 'dateMobilePlaceholderDepartureDate') || '';
  var dateMobilePlaceholderReturnDateText = getDictionaryItem(dictionary, 'dateMobilePlaceholderReturnDate') || '';
  var dateMobileStateDepartureDateSelectedText = getDictionaryItem(dictionary, 'dateMobileStateDepartureDateSelected') || '';
  var dateMobileStateDepartureReturnDateSelectedText = getDictionaryItem(dictionary, 'dateMobileStateDepartureReturnDateSelected') || '';
  var dateErrorSelectDepartureDateText = getDictionaryItem(dictionary, 'dateErrorSelectDepartureDate') || '';
  var dateErrorSelectReturnDateText = getDictionaryItem(dictionary, 'dateErrorSelectReturnDate') || '';
  var passengerText = getDictionaryItem(dictionary, 'passenger') || '';
  var classText = getDictionaryItem(dictionary, 'class') || '';
  var economyClassText = getDictionaryItem(dictionary, 'economyClass') || '';
  var businessClassText = getDictionaryItem(dictionary, 'businessClass') || '';
  var passengerDropTitleText = getDictionaryItem(dictionary, 'passengerDropTitle') || '';
  var passengerDropIntroText = getDictionaryItem(dictionary, 'passengerDropIntro') || '';
  var adultText = getDictionaryItem(dictionary, 'adult') || '';
  var adultHelpText = getDictionaryItem(dictionary, 'adultHelp') || '';
  var childText = getDictionaryItem(dictionary, 'child') || '';
  var childHelpText = getDictionaryItem(dictionary, 'childHelp') || '';
  var infantText = getDictionaryItem(dictionary, 'infant') || '';
  var infantHelpText = getDictionaryItem(dictionary, 'infantHelp') || '';
  var cabinClassText = getDictionaryItem(dictionary, 'cabinClass') || '';
  var economyText = getDictionaryItem(dictionary, 'economy') || '';
  var businessText = getDictionaryItem(dictionary, 'business') || '';
  var amountValidationTextInfants = getDictionaryItem(dictionary, 'amountValidationInfants') || '';
  var amountValidationTextTotal = getDictionaryItem(dictionary, 'amountValidationTextTotal') || '';
  var searchFlightsText = getDictionaryItem(dictionary, 'searchFlights') || '';
  var clearText = getDictionaryItem(dictionary, 'clear') || '';
  /* End Dictionary terms */

  /* States/Refs common */
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    returnTicket = _useState4[0],
    setReturnTicket = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    originalLocations = _useState6[0],
    setOriginalLocations = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    populars = _useState8[0],
    setPopulars = _useState8[1];
  var _useState9 = useState('en'),
    _useState10 = _slicedToArray(_useState9, 2),
    flyDubaiLang = _useState10[0],
    setFlyDubaiLang = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    swapLoading = _useState12[0],
    setSwapLoading = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    shouldAutoopenTo = _useState14[0],
    setShouldAutoopenTo = _useState14[1];
  /* End States/Refs common */

  /* States/Refs elements FROM field */
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    departures = _useState16[0],
    setDepartures = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    fromFocusedOnce = _useState18[0],
    setFromFocusedOnce = _useState18[1];
  var _useState19 = useState(emptyDestination),
    _useState20 = _slicedToArray(_useState19, 2),
    fromValue = _useState20[0],
    setFromValue = _useState20[1];
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    fromInputValue = _useState22[0],
    setFromInputValue = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    fromMenuOpened = _useState24[0],
    setFromMenuOpened = _useState24[1];
  var fromMenuOpenedRef = useRef(false);
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    fromInvalidFilter = _useState26[0],
    setFromInvalidFilter = _useState26[1];
  /* End states/refs elements FROM field */

  /* States/Refs elements TO field */
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    arrivals = _useState28[0],
    setArrivals = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    toFocusedOnce = _useState30[0],
    setToFocusedOnce = _useState30[1];
  var _useState31 = useState(emptyDestination),
    _useState32 = _slicedToArray(_useState31, 2),
    toValue = _useState32[0],
    setToValue = _useState32[1];
  var _useState33 = useState(""),
    _useState34 = _slicedToArray(_useState33, 2),
    toInputValue = _useState34[0],
    setToInputValue = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    toMenuOpened = _useState36[0],
    setToMenuOpened = _useState36[1];
  var toMenuOpenedRef = useRef(null);
  var _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    toInvalidFilter = _useState38[0],
    setToInvalidFilter = _useState38[1];
  /* End states/refs elements TO field */

  /* States/Refs/Memos elements DATE field */
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    dateOpened = _useState40[0],
    setDateOpened = _useState40[1];
  var dateOpenedRef = useRef(null);
  var _useState41 = useState(emptyDateShowObj),
    _useState42 = _slicedToArray(_useState41, 2),
    departureDate = _useState42[0],
    setDepartureDate = _useState42[1];
  var _useState43 = useState(emptyDateShowObj),
    _useState44 = _slicedToArray(_useState43, 2),
    returnDate = _useState44[0],
    setReturnDate = _useState44[1];
  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    dateResetFlag = _useState46[0],
    setDateResetFlag = _useState46[1];
  var _useState47 = useState(false),
    _useState48 = _slicedToArray(_useState47, 2),
    dateFromFocusedOnce = _useState48[0],
    setDateFromFocusedOnce = _useState48[1];
  var _useState49 = useState(false),
    _useState50 = _slicedToArray(_useState49, 2),
    dateToFocusedOnce = _useState50[0],
    setDateToFocusedOnce = _useState50[1];
  var _useState51 = useState([[], []]),
    _useState52 = _slicedToArray(_useState51, 2),
    datesAvailable = _useState52[0],
    setDatesAvailable = _useState52[1];
  var _useState53 = useState(canUseDOM ? window.matchMedia("(max-width: 767px)").matches : false),
    _useState54 = _slicedToArray(_useState53, 2),
    isMobile = _useState54[0],
    setIsMobile = _useState54[1];
  /* End states States/Refs/Memos elements DATE field */

  /* States/Refs/Memos elements PASSENGERS AMOUNT field */
  var _useState55 = useState(true),
    _useState56 = _slicedToArray(_useState55, 2),
    economyCabinClass = _useState56[0],
    setEconomyCabinClass = _useState56[1];
  var _useState57 = useState(1),
    _useState58 = _slicedToArray(_useState57, 2),
    adults = _useState58[0],
    _setAdults = _useState58[1];
  var _useState59 = useState(0),
    _useState60 = _slicedToArray(_useState59, 2),
    childrens = _useState60[0],
    setChildrens = _useState60[1];
  var _useState61 = useState(0),
    _useState62 = _slicedToArray(_useState61, 2),
    infants = _useState62[0],
    setInfants = _useState62[1];
  var _useState63 = useState(false),
    _useState64 = _slicedToArray(_useState63, 2),
    amountOpened = _useState64[0],
    setAmountOpened = _useState64[1];
  var amountOpenedRef = useRef(null);
  var _useState65 = useState(false),
    _useState66 = _slicedToArray(_useState65, 2),
    amountOpenFlag = _useState66[0],
    setAmountOpenFlag = _useState66[1];
  var allPassengers = useMemo(function () {
    return adults + childrens + infants;
  }, [adults, childrens, infants]);
  /* End states/refs/memos elements PASSENGERS AMOUNT field */

  /* Dropdowns show-hide */
  var hideFromDropdown, hideToDropdown, hideDateDD, hideAmountDD;
  if (canUseDOM) {
    hideFromDropdown = function hideFromDropdown(e) {
      var mobileDevice = window.matchMedia("(max-width: 767px)").matches;
      if (mobileDevice || !fromMenuOpenedRef.current || e.target.closest('.fields-wrapper__dest-departure') || e.target.closest('.location-select__more-btn')) return;
      setFromMenuOpened(false);
    };
    hideToDropdown = function hideToDropdown(e) {
      var mobileDevice = window.matchMedia("(max-width: 767px)").matches;
      if (mobileDevice || !toMenuOpenedRef.current || e.target.closest('.fields-wrapper__dest-return') || e.target.closest('.location-select__more-btn')) return;
      setToMenuOpened(false);
    };
    hideDateDD = function hideDateDD(e) {
      var mobileDevice = window.matchMedia("(max-width: 767px)").matches;
      if (mobileDevice || !dateOpenedRef.current || e.target.closest('.fields-wrapper__date') || e.target.closest('.datepicker-dropdown') || e.target.closest('.react-datepicker__day')) return;
      setDateOpened(false);
    };
    hideAmountDD = function hideAmountDD(e) {
      var mobileDevice = window.matchMedia("(max-width: 767px)").matches;
      if (mobileDevice || !amountOpenedRef.current || e.target.closest('.fields-wrapper__amount')) return;
      setAmountOpened(false);
    };
  }
  /* End Dropdowns show-hide */

  var debouncedCheckMobile = debounce(function () {
    setIsMobile(window.matchMedia("(max-width: 767px)").matches);
  }, 250);
  var dateFieldProps = {
    lang: lang,
    rtl: rtl,
    dateOpened: dateOpened,
    closeDateDropdown: function closeDateDropdown() {
      setDateOpened(false);
    },
    depDate: departureDate,
    setDepDate: setDepartureDate,
    retDate: returnDate,
    setRetDate: setReturnDate,
    resetFlag: dateResetFlag,
    setResetFlag: setDateResetFlag,
    returnTicket: returnTicket,
    setReturnTicket: setReturnTicket,
    textClear: clearText,
    oneWayText: oneWayText,
    datesAvailable: datesAvailable,
    isMobile: isMobile,
    enableAmountOpenFlag: function enableAmountOpenFlag() {
      setAmountOpenFlag(true);
    },
    mobileStateSelectDepartureDateText: dateMobileStateSelectDepartureDateText,
    mobileStateSelectReturnDateText: dateMobileStateSelectReturnDateText,
    mobilePlaceholderDepartureDateText: dateMobilePlaceholderDepartureDateText,
    mobilePlaceholderReturnDateText: dateMobilePlaceholderReturnDateText,
    mobileStateDepartureDateSelectedText: dateMobileStateDepartureDateSelectedText,
    mobileStateDepartureReturnDateSelectedText: dateMobileStateDepartureReturnDateSelectedText
  };
  var formSubmit = function formSubmit() {
    setFromFocusedOnce(true);
    setToFocusedOnce(true);
    setDateFromFocusedOnce(true);
    setDateToFocusedOnce(true);
    var allowUrlOpen = !!fromValue.value && !!toValue.value && !!departureDate.dayNumber && (!returnTicket || !!(returnTicket && returnDate.dayNumber));
    var dir = returnTicket ? 'rt' : 'ow';
    var dates = "".concat(departureDate.year).concat(departureDate.monthNumber).concat(departureDate.dayNumber);
    if (returnTicket) {
      dates += "_".concat(returnDate.year).concat(returnDate.monthNumber).concat(returnDate.dayNumber);
    }
    var thirdLevelDomain = isMobile ? 'm' : 'flights2';
    var touristsNumber = "".concat(adults ? "a".concat(adults) : '').concat(childrens ? "c".concat(childrens) : '').concat(infants ? "i".concat(infants) : '');
    var url = new URL("https://".concat(thirdLevelDomain, ".flydubai.com/").concat(flyDubaiLang, "/results/").concat(dir, "/").concat(touristsNumber, "/").concat(fromValue.value, "_").concat(toValue.value, "/").concat(dates));
    var queryString = new URLSearchParams({
      cabinClass: getClassName(economyCabinClass),
      isOriginMetro: fromValue.metroActive,
      isDestMetro: toValue.metroActive
    });
    url.search = queryString.toString();
    var anaLiticsReturnMessage = returnTicket ? 'Return' : 'One Way';
    var anaLiticsDateMessage = "".concat(departureDate.day, " ").concat(departureDate.month, " ").concat(departureDate.year);
    if (returnTicket) {
      anaLiticsDateMessage += " : ".concat(returnDate.day, " ").concat(returnDate.month, " ").concat(returnDate.year);
    }
    if (allowUrlOpen) {
      tealiumClickFunc(tealiumMergeClickData(searchSubmitAnalytics, params), [searchFlightsText, anaLiticsReturnMessage, allPassengers, fromValue.value, toValue.value, anaLiticsDateMessage]);
      window.open(url.toString());
    }
  };
  var passengersFieldProps = {
    adults: adults,
    childrens: childrens,
    infants: infants,
    setAdults: function setAdults(count) {
      _setAdults(count);
      if (count < infants) setInfants(count);
    },
    setChildrens: setChildrens,
    setInfants: setInfants,
    title: passengerDropTitleText,
    intro: passengerDropIntroText,
    textAdults: adultText,
    descriptionAdult: adultHelpText,
    textChildren: childText,
    descriptionChildren: childHelpText,
    textInfants: infantText,
    descriptionInfants: infantHelpText,
    textCabinClass: cabinClassText,
    textEconomy: economyText,
    textBusiness: businessText,
    textAmountValidationInfants: amountValidationTextInfants,
    textAmountValidationTotal: amountValidationTextTotal,
    economyCabinClass: economyCabinClass,
    setEconomyCabinClass: setEconomyCabinClass,
    textClear: clearText,
    textSave: searchFlightsText,
    rtl: rtl,
    close: function close() {
      setAmountOpened(false);
    },
    saveAction: formSubmit
  };
  var sortAndAddValues = function sortAndAddValues(airports, metros) {
    var shouldFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var currentLabel = '';
    var destinations = shouldFilter ? airports.filter(function (airport) {
      return airport.hasDestination;
    }) : airports.concat([]);
    destinations.sort(function (a, b) {
      return a.groupLabel.localeCompare(b.groupLabel) || a.city.localeCompare(b.city);
    });
    destinations.forEach(function (airport) {
      if (airport.groupLabel !== currentLabel) {
        currentLabel = airport.groupLabel;
        airport.firstInGroup = true;
      }
      airport.value = airport.airportCode;
      airport.label = airport.Name;
      var metroForAirport = metros.find(function (metro) {
        return metro.metros.includes(airport.airportCode) && !airport.metroActive;
      });
      if (metroForAirport) {
        var isMetroExists = destinations.find(function (destination) {
          return destination.metroActive && destination.airportCode === metroForAirport.org;
        });
        if (isMetroExists) {
          airport.asAMetroChild = metroForAirport.org;
        }
      }
    });
    return destinations;
  };

  /* Generate list with metroCildren after metro airport */
  var setMetrosInList = function setMetrosInList(airports, metrosHash) {
    Object.keys(metrosHash).forEach(function (key) {
      var metroIndex = airports.findIndex(function (airport) {
        return airport.metroActive && key === airport.airportCode;
      });
      if (metroIndex >= 0) {
        var metroChildrenList = [];
        metrosHash[key].forEach(function (metroChildCode) {
          var metroChildIndex = airports.findIndex(function (port) {
            return port.airportCode === metroChildCode && !port.metroActive;
          });
          if (metroChildIndex >= 0) {
            metroChildrenList.push.apply(metroChildrenList, _toConsumableArray(airports.splice(metroChildIndex, 1)));
          }
        });
        var refreshedMetroIndex = airports.findIndex(function (airport) {
          return airport.metroActive && key === airport.airportCode;
        });
        airports.splice.apply(airports, [refreshedMetroIndex + 1, 0].concat(metroChildrenList));
      }
    });
    return airports;
  };
  var getDepartures = function getDepartures(locale) {
    var reqHeaders = new Headers();
    var requestOptions = {
      method: 'GET',
      headers: reqHeaders
    };
    Promise.all([fetch("https://www.flydubai.com/".concat(locale, "/api/content/airports"), requestOptions), fetch("https://www.flydubai.com/".concat(locale, "/api/content/populardestination"), requestOptions)]).then(function (responses) {
      return Promise.all(responses.map(function (response) {
        return response.status === 200 ? response.json() : null;
      }));
    }).then(function (data) {
      var _data = _slicedToArray(data, 2),
        airports = _data[0],
        loadedPopulars = _data[1];

      /*Expand populars object with populars hash*/
      loadedPopulars.popularDestinationHash = loadedPopulars.popularDestination.reduce(function (acc, destination) {
        acc[destination.org] = destination.popularDest;
        return acc;
      }, {});

      /*Expand populars object with metros hash*/
      loadedPopulars.metrosHash = loadedPopulars.metros.reduce(function (acc, metro) {
        acc[metro.org] = metro.metros;
        return acc;
      }, {});

      /*Add current airport necessary props */
      loadedPopulars.currentAirport.value = loadedPopulars.currentAirport.airportCode;
      loadedPopulars.currentAirport.label = loadedPopulars.currentAirport.Name;
      setOriginalLocations(airports);
      setPopulars(loadedPopulars);

      // Set default current airport
      setFromValue(loadedPopulars.currentAirport);

      /* Create local var to manipulate array sort airports */
      var workingList = sortAndAddValues(airports, loadedPopulars.metros);

      /* Set the airports list to component state */
      setDepartures(setMetrosInList(workingList, loadedPopulars.metrosHash));
    }).catch(function (error) {
      console.log('catch', error);
    });
  };
  var getArrivals = function getArrivals() {
    var reqHeaders = new Headers();
    var requestOptions = {
      method: 'GET',
      headers: reqHeaders
    };
    var url = new URL("https://www.flydubai.com/".concat(flyDubaiLang, "/api/content/airports"));
    var queryString = new URLSearchParams({
      origin: fromValue.value
    });
    url.search = queryString.toString();
    fetch(url.toString(), requestOptions).then(function (response) {
      return response.status === 200 ? response.json() : null;
    }).then(function (data) {
      /* Create local var to manipulate array sort airports */
      var workingList = sortAndAddValues(data, populars.metros, false);

      /* Create most popular destination group */
      var popularDestKeys = populars.popularDestinationHash[fromValue.value] || populars.popularDestinationHash.FALLBACK;
      var popularsList = workingList.filter(function (airport) {
        return popularDestKeys.some(function (destination) {
          return airport.airportCode === destination;
        });
      });

      /* create list from new populars to apply them necessary props separately */
      if (popularsList.length) {
        popularsList.forEach(function (item, index) {
          var newProps = {
            popularItem: true
          };
          if (index === 0) newProps.isPopularHeader = true;
          popularsList[index] = _objectSpread(_objectSpread({}, newProps), item);
          if (item.asAMetroChild) delete popularsList[index].asAMetroChild;
        });
      }

      /* Set the airports list to component state */
      setArrivals([].concat(_toConsumableArray(popularsList), _toConsumableArray(setMetrosInList(workingList, populars.metrosHash))));
      if (toValue.value) {
        setToValue(workingList.find(function (airport) {
          return toValue.value === airport.airportCode && toValue.label === airport.Name;
        }));
      } else if (shouldAutoopenTo) {
        setToMenuOpened(true);
        if (!toFocusedOnce) setToFocusedOnce(true);
      } else {
        setShouldAutoopenTo(true);
      }
    }).catch(function (error) {
      console.log('catch', error);
    });
  };
  var getDates = function getDates() {
    var reqHeaders = new Headers();
    var requestOptions = {
      method: 'GET',
      headers: reqHeaders
    };
    var url = new URL("https://www.flydubai.com/api/Calendar/".concat(fromValue.value, "/").concat(toValue.value));
    var queryString = new URLSearchParams({
      fromDate: new Date().toLocaleDateString('en-GB', {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      }).replaceAll(' ', '-'),
      isOriginMetro: fromValue.metroActive,
      isDestMetro: toValue.metroActive
    });
    url.search = queryString.toString();
    fetch(url.toString(), requestOptions).then(function (response) {
      return response.status === 200 ? response.json() : null;
    }).then(function (data) {
      setDateOpened(true);
      if (swapLoading) setSwapLoading(false);
      setDatesAvailable([data.routes[0].flightSchedules, data.routes[1].flightSchedules]);
    }).catch(function (error) {
      console.log('catch', error);
    });
  };
  var returnValueChangeHandler = function returnValueChangeHandler(returnValue) {
    return function () {
      setReturnTicket(returnValue);
      var anaLiticsMessage = returnValue ? 'Return' : 'One Way';
      tealiumClickFunc(tealiumMergeClickData(returnChangeAnalytics, params), [anaLiticsMessage]);
    };
  };
  useEffect(function () {
    if (canUseDOM) {
      document.addEventListener("click", hideFromDropdown);
      document.addEventListener("click", hideToDropdown);
      document.addEventListener("click", hideDateDD);
      document.addEventListener("click", hideAmountDD);
      window.addEventListener('resize', debouncedCheckMobile);
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
      return function () {
        document.removeEventListener("click", hideFromDropdown);
        document.removeEventListener("click", hideToDropdown);
        document.removeEventListener("click", hideDateDD);
        document.removeEventListener("click", hideAmountDD);
        window.removeEventListener('resize', debouncedCheckMobile);
      };
    }
  }, []);
  useEffect(function () {
    var widgetLang = ['ar', 'ru', 'en'].includes(lang) ? lang : 'en';
    setFlyDubaiLang(widgetLang);
    getDepartures(widgetLang);
  }, [lang]);
  useEffect(function () {
    setDateResetFlag(true);
    if (fromValue.value) {
      getArrivals();
    }
  }, [fromValue]);
  useEffect(function () {
    setDateResetFlag(true);
    if (toValue.value) {
      getDates();
    } else {
      setDatesAvailable([[], []]);
    }
  }, [toValue.value]);
  useEffect(function () {
    if (departureDate.day) {
      setDateToFocusedOnce(true);
    }
  }, [departureDate]);
  useEffect(function () {
    fromMenuOpenedRef.current = fromMenuOpened;
    if (!fromMenuOpened) {
      setFromInputValue('');
      setFromInvalidFilter(false);
    } else {
      setFromValue(emptyDestination);
      setToValue(emptyDestination);
      setArrivals([]);
      setToFocusedOnce(false);
      setDateToFocusedOnce(false);
      setDateFromFocusedOnce(false);
    }
  }, [fromMenuOpened]);
  useEffect(function () {
    toMenuOpenedRef.current = toMenuOpened;
    if (!toMenuOpened) {
      setToInputValue('');
      setToInvalidFilter(false);
    } else {
      setToValue(emptyDestination);
      setDateToFocusedOnce(false);
      setDateFromFocusedOnce(false);
    }
  }, [toMenuOpened]);
  useEffect(function () {
    dateOpenedRef.current = dateOpened;
    if (dateOpened) {
      setDateFromFocusedOnce(true);
      setDateToFocusedOnce(true);
    }
  }, [dateOpened]);
  useEffect(function () {
    amountOpenedRef.current = amountOpened;
  }, [amountOpened]);

  /* Used a separate useeffect to run after click on body handler run - that closed the field after opening */
  useEffect(function () {
    if (amountOpenFlag) {
      setAmountOpened(true);
      setAmountOpenFlag(false);
    }
  }, [amountOpenFlag]);
  var variables = BackgroundColorHex ? {
    "--fly-dubai-widget-background-color": BackgroundColorHex,
    "--fly-dubai-widget-background-color-rgb": hexToRgb(BackgroundColorHex, true),
    "--fly-dubai-widget-background-active-color": ActiveColorHex,
    "--fly-dubai-widget-color": ColorHex
  } : {
    "--fly-dubai-widget-background-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--fly-dubai-widget-background-color-rgb": hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
    "--fly-dubai-widget-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--fly-dubai-widget-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  var fromError = !fromMenuOpened && fromFocusedOnce && !fromValue.value || fromInvalidFilter;
  var toError = !toMenuOpened && toFocusedOnce && !toValue.value || toInvalidFilter;
  var dateDepartureError = !departureDate.day && dateFromFocusedOnce && !dateOpened && !swapLoading;
  var dateReturnError = !returnDate.day && dateToFocusedOnce && !dateOpened && !swapLoading;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "fly-dubai-widget"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h4 fly-dubai-widget__heading",
    field: {
      value: titleWidgetText
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "form-group wiz__form-group"
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, titleWidgetText), /*#__PURE__*/React.createElement("span", {
    className: "form-label__container"
  }, /*#__PURE__*/React.createElement("input", {
    className: "fp__radio",
    type: "radio",
    onChange: returnValueChangeHandler(true),
    name: "return",
    id: "return-item",
    checked: returnTicket
  }), returnText && /*#__PURE__*/React.createElement("label", {
    htmlFor: "return-item",
    className: "form-label__radio"
  }, returnText)), /*#__PURE__*/React.createElement("span", {
    className: "form-label__container"
  }, /*#__PURE__*/React.createElement("input", {
    className: "fp__radio",
    type: "radio",
    onChange: returnValueChangeHandler(false),
    name: "return",
    id: "one-way-item",
    checked: !returnTicket
  }), oneWayText && /*#__PURE__*/React.createElement("label", {
    htmlFor: "one-way-item",
    className: "form-label__radio"
  }, oneWayText)))), /*#__PURE__*/React.createElement("div", {
    className: "form-wrapper row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper col-md d-md-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__dest ".concat(fromError || toError ? 'fields-wrapper__dest--has-error' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__dest-departure ".concat(fromError ? 'fields-wrapper__dest-departure--has-error' : '')
  }, /*#__PURE__*/React.createElement(LocationSelect, {
    rtl: rtl,
    isMobile: isMobile,
    isOpened: fromMenuOpened,
    setIsOpened: setFromMenuOpened,
    departureField: true,
    fromValue: fromValue.value,
    toValue: toValue.value,
    fieldValue: fromValue,
    locationsList: departures,
    inputValue: fromInputValue,
    setInputValue: setFromInputValue,
    setMyLocation: function setMyLocation() {
      setFromValue(populars.currentAirport);
      setFromMenuOpened(false);
    },
    setValue: setFromValue,
    focusedOnce: fromFocusedOnce,
    setFocusedOnce: function setFocusedOnce() {
      setFromFocusedOnce(true);
    },
    fromText: fromText,
    toText: toText,
    labelText: fromText,
    labelHelpText: enterDepartureText,
    headerText: enterDepartureText,
    useCurrentLocationText: useCurrentLocationText,
    loadNMoreDestinationsText: loadNMoreDestinationsText,
    mostPopularText: mostPopularText,
    mobilePlaceholder: searchHereText,
    error: fromError,
    errorEmptyText: pleaseEnterOrigin,
    errorInvalidText: enterValidDeparture,
    invalidFilter: fromInvalidFilter,
    setInvalidFilter: setFromInvalidFilter
  })), /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__dest-return ".concat(toError ? 'fields-wrapper__dest-return--has-error' : '')
  }, /*#__PURE__*/React.createElement(LocationSelect, {
    rtl: rtl,
    isMobile: isMobile,
    isOpened: toMenuOpened,
    setIsOpened: setToMenuOpened,
    departureField: false,
    fromValue: fromValue.value,
    toValue: toValue.value,
    fieldValue: toValue,
    locationsList: arrivals,
    inputValue: toInputValue,
    setInputValue: setToInputValue,
    clearField: function clearField() {
      setToMenuOpened(false);
      setFromMenuOpened(true);
    },
    setValue: setToValue,
    focusedOnce: toFocusedOnce,
    setFocusedOnce: function setFocusedOnce() {
      setToFocusedOnce(true);
    },
    textClear: clearText,
    fromText: fromText,
    toText: toText,
    labelText: toText,
    labelHelpText: enterDestinationText,
    headerText: enterDestinationText,
    loadNMoreDestinationsText: loadNMoreDestinationsText,
    mostPopularText: mostPopularText,
    mobilePlaceholder: searchHereText,
    error: toError,
    errorEmptyText: pleaseEnterDestination,
    errorInvalidText: enterValidDestination,
    invalidFilter: toInvalidFilter,
    setInvalidFilter: setToInvalidFilter
  })), toValue.hasReturn || swapLoading ? /*#__PURE__*/React.createElement("button", {
    className: "fields-wrapper__dest-swapper",
    onClick: function onClick() {
      setFromValue(departures.find(function (airport) {
        return toValue.value === airport.airportCode && toValue.label === airport.Name;
      }));
      setDateOpened(false);
      setSwapLoading(true);
      setToValue(fromValue);
    }
  }, /*#__PURE__*/React.createElement(IconSwap, {
    className: "icon"
  })) : null), /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    className: "\n                      fields-wrapper__date\n                      ".concat(returnTicket ? '' : 'fields-wrapper__date--single', "\n                      ").concat(dateDepartureError || dateReturnError ? 'fields-wrapper__date--has-error' : '', "\n                    "),
    onClick: function onClick() {
      setToFocusedOnce(true);
      if (toValue.value) {
        setDateOpened(true);
        if (!dateFromFocusedOnce) setDateFromFocusedOnce(true);
        if (!dateToFocusedOnce) setDateToFocusedOnce(true);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__date-departure ".concat(dateDepartureError ? 'fields-wrapper__date-departure--has-error' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n                        date-selector\n                        ".concat(dateOpened && !departureDate.day || departureDate.day || dateFromFocusedOnce ? '' : 'date-selector--placeholder', "\n                      ")
  }, /*#__PURE__*/React.createElement("span", {
    className: "date-selector__label is-ellipsed"
  }, dateDeskPlaceholderDepartureText)), /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value__day"
  }, departureDate.day), /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value__month"
  }, departureDate.month)), /*#__PURE__*/React.createElement(IconCalendar, {
    className: "icon"
  }), dateOpened && /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__date-arrow"
  }), dateDepartureError && /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__date-departure-error is-ellipsed"
  }, dateErrorSelectDepartureDateText)), returnTicket && /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__date-return ".concat(dateReturnError ? 'fields-wrapper__date-return--has-error' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n                          date-selector\n                          ".concat(dateOpened && departureDate.day && !returnDate.day || returnDate.day || dateToFocusedOnce ? '' : 'date-selector--placeholder', "\n                        ")
  }, /*#__PURE__*/React.createElement("span", {
    className: "date-selector__label is-ellipsed"
  }, dateDeskPlaceholderReturnText)), /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value__day"
  }, returnDate.day), /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value__month"
  }, returnDate.month)), /*#__PURE__*/React.createElement(IconCalendar, {
    className: "icon"
  }), dateReturnError && /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__date-return-error is-ellipsed"
  }, dateErrorSelectReturnDateText))), /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__amount"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__amount-passenger d-md-none",
    tabIndex: 0,
    onClick: function onClick() {
      setAmountOpened(true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "amount-label"
  }, passengerText), /*#__PURE__*/React.createElement("div", {
    className: "amount-drop"
  }, /*#__PURE__*/React.createElement("span", {
    className: "amount-main-text"
  }, allPassengers, ' ', passengerText), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__amount-class d-md-none",
    tabIndex: 0,
    onClick: function onClick() {
      setAmountOpened(true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "amount-label"
  }, classText), /*#__PURE__*/React.createElement("div", {
    className: "amount-drop"
  }, /*#__PURE__*/React.createElement("span", {
    className: "amount-main-text"
  }, economyCabinClass ? economyText : businessText), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-none d-md-flex fields-wrapper__amount-desk-inner",
    tabIndex: 0,
    onClick: function onClick() {
      setAmountOpened(true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__amount-desk-texts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "amount-label is-ellipsed"
  }, passengerText), /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__amount-desk-passengers amount-main-text is-ellipsed"
  }, allPassengers, ' ', passengerText), /*#__PURE__*/React.createElement("div", {
    className: "amount-label is-ellipsed"
  }, economyCabinClass ? economyClassText : businessClassText)), /*#__PURE__*/React.createElement(IconChevronAltDown, {
    className: "icon fields-wrapper__amount-desk-arrow"
  })), amountOpened && /*#__PURE__*/React.createElement(CountersGroup, passengersFieldProps)), /*#__PURE__*/React.createElement(Datepicker, dateFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "btn-wrapper col-md-auto"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: formSubmit
  }, searchFlightsText))))))));
};
var commonStyles = "c1nuxsww";
var ltrStyles = "l10q4gf3";
var rtlStyles = "r1sx1zc1";
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    fullWidth: true,
    minHeight: true,
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default FlyDubaiWidget;